export {Components, JSX} from './components';
export {
  Param,
  GTS,
  Tile,
  ChartType,
  ChartBounds,
  Dashboard,
  DataModel,
  DiscoveryEvent,
  Label,
  ColorLib,
  Colors,
  MapLib,
  MapTypes,
  Utils,
  GTSLib
} from "@senx/discovery-widgets";
